



















import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'

@Component
export default class PdfViewComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @Prop({ default: "" })
  title!: string

  @Prop({ default: "" })
  url!: string
}
